class StatsCounter extends HTMLElement {
  constructor() {
    super();
    this._hasConnected = false;
    this._hasPlayed = false;
  }

  connectedCallback() {
    if (this._hasConnected) return;
    this._hasConnected = true;

    // Numbers are rendered at their final value; without motion we leave them alone.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    this.duration = parseInt(this.dataset.duration, 10) || 2500;
    this.style.setProperty('--sc-duration', `${this.duration}ms`);

    this.numbers = Array.from(this.querySelectorAll('[data-count-to]')).map((el) => {
      const raw = el.dataset.countTo.replace(/,/g, '').trim();
      const target = parseFloat(raw);
      const decimals = (raw.split('.')[1] || '').length;
      return { el, target, decimals };
    }).filter((item) => !Number.isNaN(item.target));

    this.numbers.forEach((item) => {
      item.el.textContent = this.format(0, item.decimals);
    });
    this.classList.add('is-armed');

    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      this.observer.disconnect();
      this.play();
    }, { threshold: 0.25 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this._frame) cancelAnimationFrame(this._frame);
  }

  play() {
    if (this._hasPlayed) return;
    this._hasPlayed = true;
    this.classList.add('is-visible');

    const start = performance.now();
    const stagger = 110;

    const tick = (now) => {
      let running = false;

      this.numbers.forEach((item, index) => {
        // Matches the CSS reveal delay (--sc-i starts at 1 for stats)
        const elapsed = now - start - (index + 1) * stagger;
        const progress = Math.min(Math.max(elapsed / this.duration, 0), 1);
        // easeOutExpo: fast start, slow settle on the final value
        const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        item.el.textContent = this.format(item.target * eased, item.decimals);
        if (progress < 1) running = true;
      });

      if (running) this._frame = requestAnimationFrame(tick);
    };

    this._frame = requestAnimationFrame(tick);
  }

  format(value, decimals) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }
}

if (!customElements.get('stats-counter')) {
  customElements.define('stats-counter', StatsCounter);
}
